namespace TabAurous.SalesOrder {
    export namespace OrderItemsAPIService {
        export const baseUrl = '~/api/OrderItems';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<SalesOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "~/api/OrderItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>OrderItemsAPIService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
